export default __webpack_public_path__ + "static/media/Yonsei University.svg.58836dc8.webp";